
/**
 * 需要配置三个项目对应的域名跳转，这个文件需要同步到腾讯存储上cos
 * https://eestest-1252877917.cos.ap-guangzhou.myqcloud.com/orangeSetting.js"
 */
 const setting = {
  "orange_mode_zy_test": {
    "JX_URL": "https://jz.zytest.net",
    "SC_URL": "https://jz-sc.zytest.net",
    "PM_URL": "https://jz-pm.zytest.net"
  },
  "orange_mode_zy2_test": {
    "JX_URL": "https://jx2.zytest.net",
    "SC_URL": "https://sc2.zytest.net",
    "PM_URL": "https://pm2.zytest.net"
  },
  "orange_mode_zy_production": {
    "JX_URL": "https://jx.zy.com",
    "SC_URL": "https://sc.zy.com",
    "PM_URL": "https://pm.zy.com"
  },
  "orange_mode_bnchzh_test": {
    "JX_URL": "https://test-jx.bnchzh.com",
    "SC_URL": "https://test-sc.bnchzh.com",
    "PM_URL": "https://test-pm.bnchzh.com"
  },
  "orange_mode_bnchzh_production": {
    "JX_URL": "https://jx.bnchzh.com",
    "SC_URL": "https://sc.bnchzh.com",
    "PM_URL": "https://pm.bnchzh.com"
  },
  "orange_mode_gaofen_production": {
    "JX_URL": "https://jx.gaofen.com",
    "SC_URL": "https://sc.gaofen.com",
    "PM_URL": "https://pm.gaofen.com"
  },
  "orange_mode_qrz_production": {
    "JX_URL": "https://jz.zy.com",
    "SC_URL": "https://jz.zy.com/sc/front",
    "PM_URL": "https://jz.zy.com/pm/front"
  },
  "orange_mode_qrz_test": {
    "JX_URL": "https://jz.zytest.net",
    "SC_URL": "https://jz-sc.zytest.net",
    "PM_URL": "https://jz-pm.zytest.net"
  },
  "orange_mode_qrz_pre": {
    "JX_URL": "https://pre-jz.zy.com",
    "SC_URL": "https://pre-jz.zy.com/sc/front",
    "PM_URL": "https://pre-jz.zy.com/pm/front"
  }


}
window.orangeModeSetting = setting
export default setting